import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import Service from "../../Service/http";
import Input from "../../Custom/Input";
import debounce from 'lodash.debounce';

function DisplayCriteria() {
  const service = new Service();
  let [codingProfile, setCodingProfile] = useState({});
  let [sitesOptions, setSitesOptions] = useState([]);
  let [currentSite, setCurrentSite] = useState('');
  let [scorable, setScorable] = useState(0);
  let [criteriaList, setCriteriaList] = useState([])
  let [criteriaName, setCriteriaName] = useState('')

  useEffect(() => {
    service
      .get("api/sites/options")
      .then((json) => {
        setSitesOptions(json);
      })
      .catch((error) => {
        console.error(error);
      });

      service.get('api/all/criteria').then(json => {
        setCriteriaList(json);
      }).catch(err => {
        console.error(err);
      });
  }, []);



  const updateCriteria = ()=>{

    let temp = { ...codingProfile };

    // if scorable solved count needs to be updated then we can skip site as it will be common for all
    if(currentSite==null && !temp['scorable_solved_count']){
      toast.error("Select Site");
      return
    }

    if(temp['scorable_solved_count']) temp['site_name'] = ''
    else temp["site_name"] = currentSite;
    setCodingProfile(temp);

    service.post("api/site/criteria",temp)
      .then(json=>{
        toast.success("Success");
      }).catch(error=>{
        console.error(error);
        toast.error("Error");
      })
  }

  const getCriteriaInfoByNameAndSite = async (value) => {


    if(!value || !codingProfile.site_name) return;

    service.post('api/criteria/info', {criteriaName : value, siteName: codingProfile.site_name ?? currentSite})
    .then(response => {
      setCodingProfile({...codingProfile, ...response.data})
    }).catch(error => {
      console.error(error);
      setCodingProfile({criteria_name : value, site_name: codingProfile.site_name ?? currentSite})
      toast.error("Not Found");
    })
  }

  const debouncedChangeHandler = useCallback(
    debounce((nextValue) => {
      // Handle the debounced change
      getCriteriaInfoByNameAndSite(nextValue);

    }, 1000), // 1000 milliseconds debounce delay
    []
  );

  const handleChange = (value, setValue) => {
    setValue(value);
    debouncedChangeHandler(value);
  };

  return (
    <div className="container mt-3">
    <div className="container shadow bg-white row mb-5">
      <form
        onSubmit={(e)=>{
          e.preventDefault();
          updateCriteria();
        }}>
                <div className="row">

          <h1 className="text-center card-title text-primary mt-3">Criteria Management </h1>
          <div className=" col-lg-6 col-md-12 col-sm-12 mt-4  ">
            <div className="text-start">
              <b>
                <span className="text-warning"> Criteria Name </span>
              </b>
            </div>

            <div className="input-group mb-2">
              <Input placeholder={"Enter Criteria Name"} dropdownOptions={criteriaList} inputValue={criteriaName} setInputValue={setCriteriaName} onChange={(value) => {
                  handleChange(value, setCriteriaName)
              }}/>
            </div>
          </div>
          <div className="col-lg-6 col-md-12  col-sm-12 mt-5">
            <div className="input-group ">
              <label
                className="p-1 input-group-text text-primary ps-2"
                id="basic-addon1"
              >
                SITES
              </label>

              <select
                className="form-select text-primary"
                disabled={scorable > 0}
                name="site"
                onChange={(e) => {
                    setCurrentSite(e.target.value);
                    codingProfile['site_name'] = e.target.value;
                    getCriteriaInfoByNameAndSite(criteriaName)
                }}
              >
                {" "}
                <option value="">
                  SELECT SITE
                </option>
                {sitesOptions.map((ele, ind) => {
                  if(ele !="show_criteria")
                    return (

                      <option key={ind} value={ele}>
                        {ele}
                      </option>
                    );
                })}
              </select>
            </div>
          </div>
        </div>
        <div>
          <br />
          <div className="row">
            <div className=" col-lg-6 col-md-12 col-sm-12">
              <div className="text-start">
                <b>
                  <span className="text-warning"> Solved Count </span>
                </b>
              </div>

              <div className="input-group mb-2">
                <input
                  className="form-control text-primary font-monospace"
                  value={
                    codingProfile && codingProfile.solved_count
                      ? codingProfile.solved_count
                      : ""
                  }
                  type="text"
                  placeholder="Enter Solved Count"
                  name="solved_count"
                  onChange={(e) => {
                    let temp = { ...codingProfile };
                    temp["solved_count"] = e.target.value;
                    setCodingProfile(temp);
                  }}
                />
              </div>
            </div>

            <div className=" col-lg-6 col-md-12 col-sm-12">
              <div className="text-start">
                <b>
                  <span className="text-warning"> Score </span>
                </b>
              </div>

              <div className="input-group mb-2">
                <input
                  className="form-control text-primary font-monospace"
                  value={
                    codingProfile && codingProfile.score
                      ? codingProfile.score
                      : ""
                  }
                  type="text"
                  placeholder="Enter Score"
                  name="codechef"
                  onChange={(e) => {
                    let temp = { ...codingProfile };
                    temp["score"] = e.target.value;
                    setCodingProfile(temp);
                  }}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="text-start">
                <b>
                  <span className="text-warning"> Rank </span>
                </b>
              </div>

              <div className="mb-2 input-group mb-2">
                <input
                  className="form-control text-primary font-monospace"
                  value={
                    codingProfile && codingProfile.rank ? codingProfile.rank : ""
                  }
                  type="text"
                  placeholder="Enter Rank"
                  name="rank"
                  onChange={(e) => {
                    let temp = { ...codingProfile };
                    temp["rank"] = e.target.value;
                    setCodingProfile(temp);
                  }}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="text-start">
                <b>
                  <span className="text-warning"> Country Rank </span>
                </b>
              </div>

              <div className=" input-group mb-2">
                <input
                  className="form-control text-primary font-monospace"
                  value={
                    codingProfile && codingProfile.country_rank
                      ? codingProfile.country_rank
                      : ""
                  }
                  type="text"
                  placeholder="Enter Country Rank"
                  name="country_rank"
                  onChange={(e) => {
                    let temp = { ...codingProfile };
                    temp["country_rank"] = e.target.value;
                    setCodingProfile(temp);
                  }}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="text-start">
                <b>
                  <span className="text-warning"> User Rating </span>
                </b>
              </div>

              <div className=" input-group mb-2">
                <input
                  className="form-control text-primary font-monospace"
                  value={
                    codingProfile && codingProfile.user_rating
                      ? codingProfile.user_rating
                      : ""
                  }
                  type="text"
                  placeholder="Enter User Rating"
                  name="user_rating"
                  onChange={(e) => {
                    let temp = { ...codingProfile };
                    temp["user_rating"] = e.target.value;
                    setCodingProfile(temp);
                  }}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="text-start">
                <b>
                  <span className="text-warning"> Highest Rrating </span>
                </b>
              </div>

              <div className="input-group mb-2">
                <input
                  className="form-control text-primary font-monospace"
                  value={
                    codingProfile && codingProfile.highest_rating
                      ? codingProfile.highest_rating
                      : ""
                  }
                  type="text"
                  placeholder="Enter Highest Rating"
                  name="highest_rating"
                  onChange={(e) => {
                    let temp = { ...codingProfile };
                    temp["highest_rating"] = e.target.value;
                    setCodingProfile(temp);
                  }}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="text-start">
                <b>
                  <span className="text-warning"> Star Rating </span>
                </b>
              </div>

              <div className="mb-2 input-group">
                <input
                  className="form-control text-primary font-monospace"
                  value={
                    codingProfile && codingProfile.star_rating
                      ? codingProfile.star_rating
                      : ""
                  }
                  type="text"
                  placeholder="Enter Star Rating"
                  name="star_rating"
                  onChange={(e) => {
                    let temp = { ...codingProfile };
                    temp["star_rating"] = e.target.value;
                    setCodingProfile(temp);
                  }}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="text-start">
                <b>
                  <span className="text-warning"> Contests Participated </span>
                </b>
              </div>

              <div className="mb-2 input-group ">
                <input
                  className="form-control text-primary font-monospace"
                  value={
                    codingProfile && codingProfile.contests_participated
                      ? codingProfile.contests_participated
                      : ""
                  }
                  type="text"
                  placeholder="Enter Contests Participated"
                  name="contests_participated"
                  onChange={(e) => {
                    let temp = { ...codingProfile };
                    temp["contests_participated"] = e.target.value;
                    setCodingProfile(temp);
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="text-start">
                <b>
                  <span className="text-warning"> Scorable Solved Count </span>
                </b>
              </div>

              <div className="mb-2 input-group ">
                <input
                  className="form-control text-primary font-monospace"
                  value={
                    codingProfile && codingProfile.scorable_solved_count
                      ? codingProfile.scorable_solved_count
                      : ""
                  }
                  type="text"
                  placeholder="Enter Scorable Solved Count"
                  name="scorable_solved_count"
                  onChange={(e) => {
                    let temp = { ...codingProfile };
                    temp["scorable_solved_count"] = e.target.value;
                    setCodingProfile(temp);
                    setScorable(e.target.value)
                  }}
                />
              </div>
            </div>

            {currentSite=="HACKERRANK"? (
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="text-start">
                  <b>
                    <span className="text-warning">
                      {" "}
                      Hackerrank Data Structures Score{" "}
                    </span>
                  </b>
                </div>

                <div className="input-group mb-2">
                  <input
                    className="form-control text-primary font-monospace "
                    value={
                      codingProfile &&
                        codingProfile.hackerrank_data_structures_score
                        ? codingProfile.hackerrank_data_structures_score
                        : ""
                    }
                    type="text"
                    placeholder="Enter Data Structures Score"
                    name="hackerrank_data_structures_score"
                    onChange={(e) => {
                      let temp = { ...codingProfile };
                      temp["hackerrank_data_structures_score"] = e.target.value;
                      setCodingProfile(temp);
                    }}
                  />
                </div>
              </div>
            ) : null}

            {currentSite=="HACKERRANK" ? (
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="text-start">
                  <b>
                    <span className="text-warning">
                      {" "}
                      Hackerrank Algorithms Score{" "}
                    </span>
                  </b>
                </div>

                <div className=" input-group mb-2">
                  <input
                    className="form-control text-primary font-monospace"
                    value={
                      codingProfile && codingProfile.hackerrank_algorithms_score
                        ? codingProfile.hackerrank_algorithms_score
                        : ""
                    }
                    type="text"
                    placeholder="Enter Algorithms Score"
                    name="hackerrank_algorithms_score"
                    onChange={(e) => {
                      let temp = { ...codingProfile };
                      temp["hackerrank_algorithms_score"] = e.target.value;
                      setCodingProfile(temp);
                    }}
                  />
                </div>
              </div>
            ) : null}

            <div className="me-5 mb-5">
              <button
                type="submit"
                className="btn btn-primary float-end px-5"
              >

                Create / Update Criteria

              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    </div>
  );
}

export default DisplayCriteria;
